var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 176.14 118.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#181c56;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.01,
    width: 176.11,
    height: 118.89
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    className: "cls-3",
    d: "M1.81,105.21a2.77,2.77,0,0,0-.72,2.12v3.24a2.76,2.76,0,0,0,.72,2.12,3.31,3.31,0,0,0,2.28.65H6.93v.81h-3a4.43,4.43,0,0,1-3-.84A3.48,3.48,0,0,1,0,110.63v-3.35a3.48,3.48,0,0,1,.94-2.7,4.38,4.38,0,0,1,3-.85h3v.82H4.09a3.22,3.22,0,0,0-2.28.66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    className: "cls-3",
    d: "M17.77,104.54a4.16,4.16,0,0,1,.83,2.87v6.74H17.52v-6.74a3.34,3.34,0,0,0-.62-2.25,2.58,2.58,0,0,0-2-.71,3,3,0,0,0-2.27.75,3.3,3.3,0,0,0-.7,2.36v6.59H10.82V99.94H11.9v4.83a2.56,2.56,0,0,1,1.23-.86,5.86,5.86,0,0,1,1.95-.27,3.5,3.5,0,0,1,2.69.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    className: "cls-3",
    d: "M30,104.52a3.82,3.82,0,0,1,1,2.85v3.18a3.76,3.76,0,0,1-1,2.83,4.43,4.43,0,0,1-3.1.91,4.34,4.34,0,0,1-3-.91,3.77,3.77,0,0,1-1-2.83v-3.18a3.81,3.81,0,0,1,1-2.85,4.25,4.25,0,0,1,3-.92,4.39,4.39,0,0,1,3.1.92m-6,6a3.18,3.18,0,0,0,.69,2.24,2.93,2.93,0,0,0,2.23.72,3,3,0,0,0,2.27-.72,3.18,3.18,0,0,0,.69-2.24v-3.16a3.18,3.18,0,0,0-.69-2.24,3.12,3.12,0,0,0-2.27-.72,3.05,3.05,0,0,0-2.24.72,3.22,3.22,0,0,0-.68,2.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    className: "cls-3",
    d: "M42.05,104.52a3.82,3.82,0,0,1,1,2.85v3.18a3.76,3.76,0,0,1-1,2.83,4.43,4.43,0,0,1-3.1.91,4.34,4.34,0,0,1-3.05-.91,3.81,3.81,0,0,1-.95-2.83v-3.18a3.81,3.81,0,0,1,.95-2.85A4.25,4.25,0,0,1,39,103.6a4.39,4.39,0,0,1,3.1.92m-6,6a3.18,3.18,0,0,0,.69,2.24,2.93,2.93,0,0,0,2.23.72,3,3,0,0,0,2.27-.72,3.18,3.18,0,0,0,.69-2.24v-3.16a3.18,3.18,0,0,0-.69-2.24,3.12,3.12,0,0,0-2.27-.72,3.05,3.05,0,0,0-2.24.72,3.22,3.22,0,0,0-.68,2.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    className: "cls-3",
    d: "M52.78,110.67a1.92,1.92,0,0,1,.49,1.27c0,1.47-.86,2.21-2.6,2.21H46.93v-.81h3.39a2.29,2.29,0,0,0,1.4-.35,1.34,1.34,0,0,0,.45-1.13,1.36,1.36,0,0,0-.36-.92,12.45,12.45,0,0,0-1.43-1.2l-1.7-1.29a7.5,7.5,0,0,1-1.4-1.3,2,2,0,0,1-.43-1.24,2,2,0,0,1,.68-1.65,3.31,3.31,0,0,1,2-.53h3.56v.81H49.88a2.51,2.51,0,0,0-1.44.35A1.35,1.35,0,0,0,48,106a1.32,1.32,0,0,0,.32.87,8.22,8.22,0,0,0,1.23,1l1.65,1.29a9.47,9.47,0,0,1,1.61,1.42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    className: "cls-3",
    d: "M58.14,109.6v.9a2.89,2.89,0,0,0,.7,2.16,3.09,3.09,0,0,0,2.22.68h3.07v.81H61.06a4.34,4.34,0,0,1-3-.9,3.72,3.72,0,0,1-1-2.85v-3.14a3.46,3.46,0,0,1,1-2.72,4.39,4.39,0,0,1,3-.86,4.71,4.71,0,0,1,3.14.86,3.43,3.43,0,0,1,1,2.72v2.34Zm.7-4.44a2.81,2.81,0,0,0-.7,2.11v1.6h6v-1.6a2.72,2.72,0,0,0-.72-2.12,3.4,3.4,0,0,0-2.33-.64,3.16,3.16,0,0,0-2.22.65"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    className: "cls-3",
    d: "M82.81,103.73l-3.22,8.66-3.24-8.66H75.21l3.87,10-2,5.19h1.06l5.8-15.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    className: "cls-3",
    d: "M93.93,104.52a3.81,3.81,0,0,1,.95,2.85v3.18a3.75,3.75,0,0,1-.95,2.83,4.45,4.45,0,0,1-3.1.91,4.38,4.38,0,0,1-3.06-.91,3.76,3.76,0,0,1-.94-2.83v-3.18a3.81,3.81,0,0,1,.94-2.85,4.27,4.27,0,0,1,3-.92,4.36,4.36,0,0,1,3.1.92m-6,6a3.17,3.17,0,0,0,.68,2.24,3,3,0,0,0,2.24.72,3,3,0,0,0,2.26-.72,3.13,3.13,0,0,0,.69-2.24v-3.16a3.13,3.13,0,0,0-.69-2.24,3.08,3.08,0,0,0-2.26-.72,3,3,0,0,0-2.24.72,3.17,3.17,0,0,0-.68,2.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    className: "cls-3",
    d: "M107.12,110.5a3.8,3.8,0,0,1-1,2.88,4.34,4.34,0,0,1-3,.89,4.42,4.42,0,0,1-3-.88,3.83,3.83,0,0,1-.95-2.89v-6.77h1.08v6.69a3.27,3.27,0,0,0,.69,2.33,3,3,0,0,0,2.21.7,2.9,2.9,0,0,0,2.19-.7,3.31,3.31,0,0,0,.67-2.33v-6.69h1.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    className: "cls-3",
    d: "M116.71,103.73v1h-.53a2.94,2.94,0,0,0-2.42.93,4.62,4.62,0,0,0-.77,2.93v5.59h-1.08V106.9a12.32,12.32,0,0,0-.1-1.61,13.37,13.37,0,0,0-.27-1.56h1.1a17.85,17.85,0,0,1,.3,2.18,3.17,3.17,0,0,1,1.14-1.6,3.55,3.55,0,0,1,2.1-.58Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    className: "cls-3",
    d: "M139.57,104.52a3.8,3.8,0,0,1,.82,2.68v7h-1.08v-7a3,3,0,0,0-.61-2.07,2.51,2.51,0,0,0-1.93-.68,2.34,2.34,0,0,0-1.86.68,3,3,0,0,0-.6,2.07v7h-1.1v-7a3.13,3.13,0,0,0-.6-2.07,2.44,2.44,0,0,0-1.9-.68,2.31,2.31,0,0,0-1.87.71,3.34,3.34,0,0,0-.6,2.15v6.84h-1.08V103.73h1.08V105a2.82,2.82,0,0,1,2.75-1.38,2.87,2.87,0,0,1,3,1.66,2.87,2.87,0,0,1,3-1.66,3.34,3.34,0,0,1,2.59.88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    className: "cls-3",
    d: "M151.79,104.52a3.82,3.82,0,0,1,1,2.85v3.18a3.76,3.76,0,0,1-1,2.83,4.43,4.43,0,0,1-3.1.91,4.34,4.34,0,0,1-3.05-.91,3.81,3.81,0,0,1-.95-2.83v-3.18a3.81,3.81,0,0,1,.95-2.85,4.25,4.25,0,0,1,3.05-.92,4.39,4.39,0,0,1,3.1.92m-6,6a3.18,3.18,0,0,0,.69,2.24,2.93,2.93,0,0,0,2.23.72,3,3,0,0,0,2.27-.72,3.18,3.18,0,0,0,.69-2.24v-3.16a3.18,3.18,0,0,0-.69-2.24,3.12,3.12,0,0,0-2.27-.72,3.05,3.05,0,0,0-2.24.72,3.22,3.22,0,0,0-.68,2.24Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    className: "cls-3",
    d: "M160.44,112.94l3.39-9.21H165l-4,10.42h-1.14l-4-10.42h1.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    className: "cls-3",
    d: "M169.08,109.6v.9a2.85,2.85,0,0,0,.7,2.16,3.06,3.06,0,0,0,2.21.68h3.08v.81H172a4.36,4.36,0,0,1-3-.9,3.72,3.72,0,0,1-1-2.85v-3.14a3.5,3.5,0,0,1,1-2.72,4.41,4.41,0,0,1,3-.86,4.68,4.68,0,0,1,3.14.86,3.4,3.4,0,0,1,1,2.72v2.34Zm.7-4.44a2.77,2.77,0,0,0-.7,2.11v1.6h6v-1.6a2.76,2.76,0,0,0-.72-2.12,3.44,3.44,0,0,0-2.34-.64,3.15,3.15,0,0,0-2.21.65"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    className: "cls-3",
    d: "M4.84,85.89Q0,80.72.05,68.59V22.47q0-12.28,4.71-17.38T20.44,0Q31.25,0,36,5.09t4.78,17.38V68.59q0,12.14-4.78,17.3t-15.6,5.17q-10.82,0-15.6-5.17m29-1.72Q38,79.52,38,68.59V22.47q0-10.93-4.15-15.58T20.44,2.25Q11,2.25,7,6.81T2.88,22.47V68.59Q2.88,79.68,7,84.24t13.49,4.57q9.25,0,13.41-4.64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    className: "cls-3",
    d: "M171.27,6.27Q166.49.08,155.67.08q-11,0-15.69,6.19t-4.7,21.11V83.43a43.25,43.25,0,0,0,.48,7c.23.68,1.17.64,1.88.47a1,1,0,0,0,.76-1c-.19-2-.29-4.1-.29-6.43V27.38q0-13.47,4.07-19t13.49-5.55q9.24,0,13.4,5.64t4.16,18.93V83.43a47.24,47.24,0,0,1-.22,5.71,4.18,4.18,0,0,0,.16,1.45c.16.5.86.45,1.37.46A1.13,1.13,0,0,0,175.63,90a40.82,40.82,0,0,0,.41-6.54V27.38q0-14.92-4.77-21.11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    className: "cls-3",
    d: "M127.12,1.52A1.21,1.21,0,0,0,125.91.31h-.42a1.21,1.21,0,0,0-1.21,1.21V62.41q0,13.94-4.16,19.86t-13.41,5.92q-9.4,0-13.48-5.83c-2-2.82-2.7-7.07-3.23-12.83,0-.84-.25-4.59-.25-7.12,0,0-.19-56.2-.28-56.4V1.52A1.21,1.21,0,0,0,88.26.31h-.42a1.22,1.22,0,0,0-1.22,1.21V6c-.1.21-.3,56.43-.3,56.43,0,2.5-.18,6.18-.2,6.94-.55,5.7-1.34,10.05-3.35,12.92q-4.15,5.92-13.41,5.92T55.87,82.36q-4.08-5.82-4.07-20V10.19a.92.92,0,0,0,.05-.28V1.52A1.22,1.22,0,0,0,50.64.3h-.42A1.22,1.22,0,0,0,49,1.52V3.27c0,.1,0,.21,0,.31V62.41q0,15.47,4.78,22t15.6,6.59q10.83,0,15.6-6.59A21.17,21.17,0,0,0,88,77.67a21.38,21.38,0,0,0,3.07,6.79q4.79,6.6,15.6,6.59t15.6-6.59q4.78-6.58,4.78-22V10s0-.07,0-.11Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.f505f4ef6ae4f557e9fded9e43d4c612.svg";
export { ForwardRef as ReactComponent };